<template>
  <div class="bg-primary-600">
    <label for="product-search" class="mb-2 text-sm font-medium text-gray-900 sr-only">Search</label>
    <div class="relative">
      <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
        <svg class="w-[15px] h-[15px] text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
        </svg>
      </div>
      <input
        class="block w-full ps-10 p-2 text-gray-900 border-2 border-secondary-600 rounded-lg bg-gray-50 text-base focus:ring-secondary-600 focus:border-secondary-600"
        id="product-search"
        type="text"
        placeholder="Search products"
        v-model="filter"
      >
      <button
        @click="SetSearchTextFilter(null)"
        class="absolute inset-y-0 flex items-center ps-3 right-[10px]"
        type="button"
        v-if="Filter"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[15px] h-[15px] text-secondary-600">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useProductsStore } from '@/stores/products';

const {
  SetSearchTextFilter,
} = useProductsStore();
const Filter = computed(() => useProductsStore().SearchTextFilter);

const filter = computed({
  get() {
    return Filter.value;
  },
  set(v) {
    SetSearchTextFilter(v);
  },
});
</script>
